/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import React, { useEffect, useState } from 'react'
import { Row, Button, Typography, Tooltip } from 'antd'
import { PlusOutlined, LineOutlined } from '@ant-design/icons'
import styles from './CurrencyBalanceCardsButtons.module.scss'
import { selectCurrencyToken, selectUser, summaryBalanceSelector } from 'src/features'
import { CustomModal, DepositForm, WithdrawForm, CustomCol } from 'src/components'
import { getPendingSales } from 'src/features/sales/api'
import Link from 'next/link'
import { PendingSale } from 'src/core/models/sales-slice.type'

const CurrencyBalanceCardsButtons: React.FC = () => {
  const { t } = useTranslation()
  const { is_project_developer } = useAppSelector(selectUser)
  const currency_code = useAppSelector(selectCurrencyToken)
  const { list: balanceList, loading } = useAppSelector(summaryBalanceSelector)
  const [isBtnWithdrawDisable, setIsBtnWithdrawDisable] = useState(false)
  const [isModalDepositVisible, setIsModalDepositVisible] = useState(false)
  const [isModalWithdrawVisible, setIsModalWithdrawVisible] = useState(false)

  const [pendingSales, setPendingSales] = useState<PendingSale[]>([])

  const handleCheckBalance = () => {
    const selectBalance = balanceList.find(item => item.code === currency_code)
    setIsBtnWithdrawDisable(selectBalance?.balance === 0)
  }

  useEffect(() => { handleCheckBalance() }, [balanceList, currency_code])

  useEffect(() => {
    if(is_project_developer){
      getPendingSales().then(sales=>setPendingSales(sales))
    }
  }, [is_project_developer])


  return <div className={styles.buttonsMargin}>
    <Row className={styles.content}>
      <CustomCol lg={11}>
        <Button
          type='primary'
          size='large'
          shape='round'
          onClick={() => setIsModalDepositVisible(true)}
          className='radius-100'
          block
        >
          <span><PlusOutlined /> {t('Summary.Deposit')}</span>

        </Button>
      </CustomCol>
      <CustomCol lg={11}>
        {isBtnWithdrawDisable ? <Tooltip placement='bottom' title={t('Summary.CannotWithdraw')}>
          <Button
            block
            size='large'
            type='default'
            loading={loading}
            disabled={isBtnWithdrawDisable}
            onClick={() => setIsModalWithdrawVisible(true)}
            className={styles.registrationButton}
          >
            <LineOutlined /> {t('Summary.Withdraw')}
          </Button>
        </Tooltip>  : <Button
          block
          size='large'
          type='default'
          loading={loading}
          disabled={isBtnWithdrawDisable}
          onClick={() => setIsModalWithdrawVisible(true)}
          className={styles.registrationButton}
        >
          <Typography.Text className='text-color-primary'>
            <LineOutlined /> {t('Summary.Withdraw')}
          </Typography.Text>
        </Button>}
      </CustomCol>
    </Row>

    {/* Deposit Modal */}
    <CustomModal
      width={450}
      footer={null}
      destroyOnClose
      title={t('Summary.Deposit')}
      onCancel={() => setIsModalDepositVisible(false)}
      open={isModalDepositVisible}
    >
      <DepositForm handleCancel={() => setIsModalWithdrawVisible(false)} />
    </CustomModal>

    {/* Withdraw Modal */}
    <CustomModal
      width={450}
      footer={null}
      destroyOnClose
      title={t('Summary.Withdraw')}
      onCancel={() => setIsModalWithdrawVisible(false)}
      open={isModalWithdrawVisible}
    >
      {is_project_developer && pendingSales?.length > 0 ?
        <div style={{ maxHeight: '50vh',overflowY: 'auto' }}>
          <div className='ant-modal-title'>
            {t('Summary.UploadPendingSales')}
          </div>
          <br />
          {pendingSales.map(s=>
            <Link key={'pending-sale-'+s.id} href={`/my-sales/details?id=${s.id}`}>
              {s.project}
              <br />
            </Link>)}
        </div>
        :
        <WithdrawForm handleCancel={() => setIsModalWithdrawVisible(false)} />
      }
    </CustomModal>
  </div>
}

export default CurrencyBalanceCardsButtons
